import "../Tooltip.css";
import { jsx } from "react/jsx-runtime";
import { Tooltip as Tooltip$1 } from "antd";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "Tooltip_base_404d7";
const css = {
  base
};
const Tooltip = ({
  content,
  mouseEnterDelay,
  open,
  placement = "top",
  ...props
}) => {
  const {
    themeSettings: { className }
  } = useTheme();
  return /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      autoAdjustOverflow: true,
      className,
      mouseEnterDelay,
      open,
      overlayClassName: [className, css.base].join(" "),
      placement,
      title: content,
      ...props
    }
  );
};
export {
  Tooltip as default
};
